// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2jmKW","containerItemsCenter":"Skeleton_containerItemsCenter__19Ap_"};